
/* eslint-disable array-callback-return */
import React, { useCallback, useState, useEffect } from "react";
import cn from "classnames";
import { getRequest } from "../../services/axiosBaseClient";
import styles from "./Layout.module.scss";
import LayoutComponent from "./LayoutComponent";
import { makePropGetter } from "react-table";
import { useParams } from "react-router-dom";

var data = {
  statusCode: 200,
  message: "This is site list...",
  error: false,
  data: [
    {
      faultySlots: 19,
      temperature: 30,
      name: "string123",
      occupiedSlots: 11,
      availableSlots: 10,
      swaps: 35,
    },
  ],
};

export default function Layout(props) {
  const siteId = props.siteId;
  const enterprise = props.enterprise;
  const [siteData, setSiteData] = useState([]);

  const getSiteLayoutData = useCallback(async () => {
    console.log("am running");
    await getRequest("bss/getSiteLayout?siteId=" + siteId).then((res) => {
      if (res && res?.data) {
        setSiteData(res.data);
      }
    });
  }, []);

  useEffect(() => {
    getSiteLayoutData();
  }, [getSiteLayoutData]);

  return (
    <div className={cn(styles.group, styles.group_layout)}>
      {siteData.map((i) => {
        return <LayoutComponent data={i}></LayoutComponent>;
      })}
      <div
        className={cn(styles.cover_block, styles.cover_block_layout)}
        style={{ visibility: "hidden" }}
      ></div>
      <div
        className={cn(styles.cover_block, styles.cover_block_layout)}
        style={{ visibility: "hidden" }}
      ></div>
      <div
        className={cn(styles.cover_block, styles.cover_block_layout)}
        style={{ visibility: "hidden" }}
      ></div>
    </div>
  );
}
